module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-78.7c63602.woff2";